import { useEffect, useMemo, useState } from 'react';
import { Editor } from '@meitu/saas-editor-core';
import type { ChartLayer } from '@meitu/saas-editor-core/es/layers/chart-layer';
import { IChartLayer, LayerType } from '@meitu/saas-editor-core/es/version-types';

/** 图表选中时才可调用 */
export const useLayerAndActiveChartInfo = (editor: Editor, layerId: string) => {
    const [layer, setLayer] = useState<IChartLayer>(() => editor.services.flatLayer.getLayer(layerId) as IChartLayer);
    const activeChartInfo = useMemo(() => editor.getInstance<ChartLayer>('ChartLayer').getChartInfo(layer), [layer]);

    useEffect(() => {
        const newLayer = editor.services.frame.getActivePickLayer(true);
        if (newLayer?.layerType !== LayerType.CHART) return;
        setLayer(newLayer as IChartLayer);
        const listenerId = editor.services.flatLayer.onChange(() => {
            const newLayer = editor.services.frame.getActivePickLayer(true) ?? null;
            if (!newLayer || newLayer.layerType !== LayerType.CHART) return;
            setLayer(newLayer as IChartLayer);
        }, layerId);
        return () => {
            editor.off(listenerId);
        };
    }, [layerId]);

    return {
        layer,
        activeChartInfo,
    };
};
